















import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component
export default class CustomButton extends Vue {

  @Prop()
  customClass?: string[];

  @Prop()
  type?: string;

  @Prop()
  keyTranslation!:  string;

  @Prop()
  text!:  string;

  @Prop({default: false})
  isDisabled!: boolean

  get translations() {
    return this.$store.state.translations.data;
  }

  @Emit('click')
  clickEvent() {}

}

